import React from 'react';
import { ITab } from '../../interfaces/umbracoNodes/contentSlices';
import RichTextAccordions from '../richTextAccordions/richTextAccordions';
import * as StyledTabs from './tabs.styles';

interface Props {
	content: ITab;
	activeTab: string;
}

const Tab = ({ content, activeTab }: Props) => {
	return (
		<StyledTabs.TabContent active={activeTab === content.Values.Title}>
			{content.Values.Sections.map(section => (
				<RichTextAccordions key={section.Values.Title} content={section} />
			))}
		</StyledTabs.TabContent>
	);
};

export default Tab;
